import { render, staticRenderFns } from "./CounterLinkPopup.vue?vue&type=template&id=2c8351ff&scoped=true"
import script from "./CounterLinkPopup.vue?vue&type=script&lang=js"
export * from "./CounterLinkPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8351ff",
  null
  
)

export default component.exports